/* Size guide drawer (Kt) — opens from any [aria-controls] trigger pointing at it on the new PDP. */

class KtSizeGuide extends HTMLElement {
  onTriggerClick = (event) => {
    const trigger = event.target.closest(`[aria-controls="${this.id}"]`);
    if (!trigger) return;
    event.preventDefault();
    this.open(trigger);
  };

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.querySelectorAll(`body > kt-size-guide#${this.id}`).forEach((stale) => stale.remove());
      document.body.appendChild(this);
      return;
    }

    if (!this.wired) {
      this.wired = true;
      this.panel = this.querySelector('.kt-size-guide__panel');
      this.closeButton = this.querySelector('.kt-size-guide__close');

      this.querySelector('.kt-size-guide__overlay').addEventListener('click', this.close.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      this.setupScrollbars();
    }

    document.addEventListener('click', this.onTriggerClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onTriggerClick);
  }

  // iOS ignores ::-webkit-scrollbar styling, so mobile gets a drawn indicator under each scrollable table.
  setupScrollbars() {
    this.scrollbars = [...this.querySelectorAll('.kt-size-guide__table')].map((table) => {
      const track = document.createElement('div');
      track.className = 'kt-size-guide__scrollbar';
      track.setAttribute('aria-hidden', 'true');
      const thumb = document.createElement('span');
      track.appendChild(thumb);
      table.after(track);

      const update = () => {
        const { scrollWidth, clientWidth, scrollLeft } = table;
        const overflowing = scrollWidth - clientWidth > 1;
        track.hidden = !overflowing;
        if (!overflowing) return;
        thumb.style.width = `${(clientWidth / scrollWidth) * 100}%`;
        thumb.style.transform = `translateX(${(scrollLeft / clientWidth) * 100}%)`;
      };

      table.addEventListener('scroll', update, { passive: true });
      return update;
    });

    this.updateScrollbars = () => this.scrollbars.forEach((update) => update());
    window.addEventListener('resize', this.updateScrollbars);
  }

  open(trigger) {
    this.trigger = trigger;
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      this.classList.add('active');
      this.updateScrollbars();
      trapFocus(this.panel, this.closeButton);
    });
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', 'false');
      removeTrapFocus(this.trigger);
    }
  }
}

customElements.define('kt-size-guide', KtSizeGuide);
